<template>
  <div class="accesslink-list-view">
    <v-row v-for="node in nodes" :key="node.id" class="mt-1" no-gutters>
      <v-col offset="0" cols="12" offset-md="2" md="8" class="py-0">
        <AccesslinkListNodeItem :node="node" :code="code"/>
      </v-col>
    </v-row>
    <v-row v-for="pod in pods" :key="pod.id" class="mt-1" no-gutters>
      <v-col offset="0" cols="12" offset-md="2" md="8" class="py-0">
        <AccesslinkListPodItem :pod="pod" :code="code" :currentNodeId="currentNodeId" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import AccesslinkListPodItem from '@/routes/accesslink2/components/list-view/AccesslinkListPodItem.vue';
import AccesslinkListNodeItem from '@/routes/accesslink2/components/list-view/AccesslinkListNodeItem.vue';

export default {
  name: "AccesslinkListView",
  components: { AccesslinkListNodeItem, AccesslinkListPodItem },
  props: {
    pods: {
      type: Array,
      required: true
    },
    nodes: {
      type: Array,
      required: true,
    },
    currentNodeId: {
      type: String,
      required: false,
    },
    code: {
      type: String,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.accesslink-list-view .v-card {
  background-color: rgb(var(--v-theme-tw-surface));
}
</style>
